var quizQuestions = [
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ပိုင် MEHL (ဦးပိုင်) မှ ထုတ်လုပ်သည့် ဘီယာကို ရွေးပေးပါ။",
      answers: [
          {
              type: "Army",
              content: "Myanmar ဘီယာ"
          },
          {
              type: "Public1",
              content: "Tiger ဘီယာ"
          },
          {
              type: "Public2",
              content: "Chang ဘီယာ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန် သောက်ရေသန့်ကို ရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "နေပြည်တော် သောက်ရေသန့်"
          },
          {
              type: "Public1",
              content: "Alpine သောက်ရေသန့်"
          },
          {
              type: "Public2",
              content: "Asia သောက်ရေသန့်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "အဓိပတိ ဆန်"
          },
          {
              type: "Public1",
              content: "Pioneer သောက်ရေသန့်"
          },
          {
              type: "Public2",
              content: "Asia အချိုရည်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သော ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Premium Gold ဆေးလိပ်"
          },
          {
              type: "Public1",
              content: "Sunday ကော်ဖီ"
          },
          {
              type: "Public2",
              content: "Signal သွားတိုက်ဆေး"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန် ဘိလပ်မြေမှာ",
      answers: [
          {
              type: "Army",
              content: "ဆင်မင်း ဘိလပ်မြေ"
          },
          {
              type: "Public1",
              content: "Crown ဘိလပ်မြေ"
          },
          {
              type: "Public2",
              content: "Apache ဘိလပ်မြေ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန် ကော်ဖီကို ရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "နန်းမြိုင် ကော်ဖီ"
          },
          {
              type: "Public1",
              content: "Sunday ကော်ဖီ"
          },
          {
              type: "Public2",
              content: "ဟော်နန်း ကော်ဖီ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်ကို ရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "Seven နို့ဆီ"
          },
          {
              type: "Public1",
              content: "Designer သောက်ရေသန့်"
          },
          {
              type: "Public2",
              content: "ကြယ်နီ ဆေးပေါ့လိပ်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ စစ်တပ်နှင့် ဆက်စပ်သော ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "ပြင်ဦးလွင် ကော်ဖီ"
          },
          {
              type: "Public1",
              content: "One Tea နို့ဆီ"
          },
          {
              type: "Public2",
              content: "ABC ဘီယာ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သော လုပ်ငန်းမှာ",
      answers: [
          {
              type: "Army",
              content: "ဗန္ဓုလသယ်ယူပို့ဆောင်ရေးကုမ္ပဏီလီမိတက်"
          },
          {
              type: "Public1",
              content: "ရွှေစင်စင်္ကြာခရီးသည်ပို့ဆောင်ရေးလုပ်ငန်း"
          },
          {
              type: "Public2",
              content: "ဝင်း Express"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Royal Karawait သကြား"
          },
          {
              type: "Public1",
              content: "Super ကွေကာ"
          },
          {
              type: "Public2",
              content: "Royal D အားဖြည့်အချိုရည်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Mytel ဆင်းကဒ်"
          },
          {
              type: "Public1",
              content: "Red bull အချိုရည်"
          },
          {
              type: "Public2",
              content: "စိန်ဘယက်တိုင်းရင်းဆေး"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်ကို ရွေးပေးပါ။",
      answers: [
          {
              type: "Army",
              content: "ငွေပင်လယ် ပင်လယ်စာထုတ်ကုန်များ"
          },
          {
              type: "Public1",
              content: "Crown ဘိလပ်မြေ"
          },
          {
              type: "Public2",
              content: "Paris ဆပ်ပြာ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ စစ်တပ်နှင့်ဆက်နွယ်သော ထုတ်ကုန်ကို ရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "First Choice အမဲသားစည်သွပ်ဗူး"
          },
          {
              type: "Public1",
              content: "အမေထွား ပဲဆီသန့်"
          },
          {
              type: "Public2",
              content: "Meizan နေကြာဆီ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်ကို ရွေးပေးပါ။",
      answers: [
          {
              type: "Army",
              content: "Dagon ဘီယာ"
          },
          {
              type: "Public1",
              content: "လက်ကီး ခေါက်ဆွဲ"
          },
          {
              type: "Public2",
              content: "Designer သောက်ရေသန့်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့် ဆက်နွယ်သော လုပ်ငန်းကို ရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "အောင်သစ္စာဦး အသက်အာမခံလုပ်ငန်း"
          },
          {
              type: "Public1",
              content: "စိန်ဘယက်တိုင်းရင်းဆေးလုပ်ငန်း"
          },
          {
              type: "Public2",
              content: "အရီးထောင်းလက်ဖက်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့် ဆက်နွယ်သော လုပ်ငန်းကို ရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "Sky one ဆောက်လုပ်ရေးလုပ်ငန်း"
          },
          {
              type: "Public1",
              content: "FAME pharmaceuticals"
          },
          {
              type: "Public2",
              content: "စိန်ဘယက်တိုင်းရင်းဆေးလုပ်ငန်း"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Dentomec သွားတိုက်ဆေး"
          },
          {
              type: "Public1",
              content: "Signal သွားတိုက်ဆေး"
          },
          {
              type: "Public2",
              content: "3D သွားတိုက်ဆေး"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "ပဒုမ္မာ ဆပ်ပြာ"
          },
          {
              type: "Public1",
              content: "Lion အချိုရည်"
          },
          {
              type: "Public2",
              content: "Clear ခေါင်းလျှော်ရည်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "မြနန္ဒာ သောက်ရေသန့်"
          },
          {
              type: "Public1",
              content: "အမေထွား ပဲဆီသန့်"
          },
          {
              type: "Public2",
              content: "လက်ဝှေ့ကျော် ခြင်ဆေးခွေ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ စစ်တပ်နှင့် ဆက်နွယ်သော ဖျော်ဖြေရေးလုပ်ငန်းကို ရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "Stellar Seven Entertainment"
          },
          {
              type: "Public1",
              content: "Mafia Entertainment"
          },
          {
              type: "Public2",
              content: "House of Media & Entertainment"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်ဘီယာကိုရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "Black Shield ဘီယာ"
          },
          {
              type: "Public1",
              content: "ABC ဘီယာ"
          },
          {
              type: "Public2",
              content: "Tiger ဘီယာ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "ရွှေဖီဦး တီးမစ်"
          },
          {
              type: "Public1",
              content: "Super ကွေကာ"
          },
          {
              type: "Public2",
              content: "Nescafe ကော်ဖီ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "သုတအလင်းမဂ္ဂဇင်း (Knowledge Light Magazine)"
          },
          {
              type: "Public1",
              content: "Miss ခေါင်းလျှော်ရည် "
          },
          {
              type: "Public2",
              content: "Designer Water"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်ကိုရွေးပါ။",
      answers: [
          {
              type: "Army",
              content: "Myawaddy TV"
          },
          {
              type: "Public1",
              content: "Skynet"
          },
          {
              type: "Public2",
              content: "Cannel +"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "နန်းမြိုင်ကော်ဖီ"
          },
          {
              type: "Public1",
              content: "Sunday ကော်ဖီ"
          },
          {
              type: "Public2",
              content: "Nescafe ကော်ဖီ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့် ဆက်နွယ်သောထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "PTT Oil"
          },
          {
              type: "Public1",
              content: "Shark အချိုရည်"
          },
          {
              type: "Public2",
              content: "ရွှေနဂါးစိုက်ပျိုးရေးသုံးဓါတ်မြေဩဇာ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သော စီးပွားရေးလုပ်ငန်းမှာ",
      answers: [
          {
              type: "Army",
              content: "7th Sense Entertainment"
          },
          {
              type: "Public1",
              content: "ဦးချိန်တီ တိုင်းရင်းဆေးလုပ်ငန်း"
          },
          {
              type: "Public2",
              content: "ကြယ်နီဆေးပေါ့လိပ်လုပ်ငန်း"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "MEC Rice"
          },
          {
              type: "Public1",
              content: "Life သောက်ရေသန့်"
          },
          {
              type: "Public2",
              content: "Premier ကော်ဖီ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Star Mask"
          },
          {
              type: "Public1",
              content: "ကွမ်းရွက်ပုံ တိုင်းရင်းဆေး"
          },
          {
              type: "Public2",
              content: "Life သောက်ရေသန့်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Sigma Wire"
          },
          {
              type: "Public1",
              content: "Sogo plastics"
          },
          {
              type: "Public2",
              content: "Red Bull အချိုရည်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Vega plastics"
          },
          {
              type: "Public1",
              content: "Life သောက်ရေသန့်"
          },
          {
              type: "Public2",
              content: "Crown ဘိလပ်မြေ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Dentomec သွားတိုက်ဆေး"
          },
          {
              type: "Public1",
              content: "Carabao အချိုရည်"
          },
          {
              type: "Public2",
              content: "မြကြာဖြူလုံချည်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "First Choice စည်သွပ်ဗူး"
          },
          {
              type: "Public1",
              content: "အမေထွားပဲဆီသန့်"
          },
          {
              type: "Public2",
              content: "Fire Dragon အချိုရည်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သော ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "ရှမ်းမလေး Express"
          },
          {
              type: "Public1",
              content: "ရှမ်း‌ရွှေတောင် လက်ဖက်"
          },
          {
              type: "Public2",
              content: "Fire Dragon အချိုရည်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Myanmar Mobile Pay"
          },
          {
              type: "Public1",
              content: "Ooredoo Myanmar"
          },
          {
              type: "Public2",
              content: "Samsung"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ပိုင်စီးပွားရေးလုပ်ငန်းမှာ",
      answers: [
          {
              type: "Army",
              content: "Myawaddy Travels & Tours"
          },
          {
              type: "Public1",
              content: "ရွှေစင်စင်္ကြာခရီးသည်ပို့ဆောင်ရေး"
          },
          {
              type: "Public2",
              content: "အောင်သမာဓိရွှေဆိုင်လုပ်ငန်း"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သည့် လုပ်ငန်းမှာ",
      answers: [
          {
              type: "Army",
              content: "Ruby Mart"
          },
          {
              type: "Public1",
              content: "Junction Square"
          },
          {
              type: "Public2",
              content: "Super One Mark"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သော ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Ruby Mart"
          },
          {
              type: "Public1",
              content: "Junction Square"
          },
          {
              type: "Public2",
              content: "Super One Mark"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Myawaddy Bank"
          },
          {
              type: "Public1",
              content: "Ayawaddy Bank"
          },
          {
              type: "Public2",
              content: "Ocean Supermarket"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "မြဝတီသောက်ရေသန့်"
          },
          {
              type: "Public1",
              content: "Life သောက်ရေသန့်"
          },
          {
              type: "Public2",
              content: "Designer သောက်ရေသန့်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Premium Gold ဆေးလိပ်"
          },
          {
              type: "Public1",
              content: "Red Bull အချိုရည်"
          },
          {
              type: "Public2",
              content: "Tiger ဘီယာ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "ငွေတာရီမဂ္ဂဇင်း"
          },
          {
              type: "Public1",
              content: "FAME pharmaceuticals"
          },
          {
              type: "Public2",
              content: "ရွှေမြင်းပျံဟာလဝါ"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "ငွေပင်လယ်ငါးထုတ်ကုန်များ"
          },
          {
              type: "Public1",
              content: "Surprise အချိုရည်"
          },
          {
              type: "Public2",
              content: "ထွန်းရွှေဝါတိုင်းရင်းဆေး"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Milky နို့ဆီ"
          },
          {
              type: "Public1",
              content: "ဒီဇင်ဘာ နွားနို့"
          },
          {
              type: "Public2",
              content: "အရီးထောင်းလက်ဖက်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Life အုန်းဆီ"
          },
          {
              type: "Public1",
              content: "Rich ကော်ဖီ"
          },
          {
              type: "Public2",
              content: "ထွန်းရွှေဝါ တိုင်းရင်းဆေး"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "TRISTAR CGI Sheet"
          },
          {
              type: "Public1",
              content: "Sogo plastics"
          },
          {
              type: "Public2",
              content: "Apolo ဗလာစာအုပ်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Rhino Cement"
          },
          {
              type: "Public1",
              content: "Sogo plastics"
          },
          {
              type: "Public2",
              content: "Crown Cement"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သော လုပ်ငန်းမှာ",
      answers: [
          {
              type: "Army",
              content: "PRO BUILDERS GROUP Co, Ltd"
          },
          {
              type: "Public1",
              content: "FAME pharmaceuticals"
          },
          {
              type: "Public2",
              content: "Ocean Supermarkets"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "မြင်းပျံ ဘိလပ်မြေ"
          },
          {
              type: "Public1",
              content: "Red Bull အချိုရည်"
          },
          {
              type: "Public2",
              content: "Sunday ကော်ဖီမစ်"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်နှင့်ဆက်နွယ်သော ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Central Hotel (Yangon)"
          },
          {
              type: "Public1",
              content: "Canel +"
          },
          {
              type: "Public2",
              content: "Super One Mark"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "Royal Sportainment Complex"
          },
          {
              type: "Public1",
              content: "Ocean Supermarkets"
          },
          {
              type: "Public2",
              content: "Super One Mark"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "The Yangon Gallery"
          },
          {
              type: "Public1",
              content: "Super One Mark"
          },
          {
              type: "Public2",
              content: "Sogo plastics"
          }
      ]
  },
  {
      question: "အောက်ပါတို့မှ သပိတ်မှောက်ရမည့် စစ်တပ်ထုတ်ကုန်မှာ",
      answers: [
          {
              type: "Army",
              content: "ဒေါင်းလန်းကြီးစားသောက်ဆိုင်"
          },
          {
              type: "Public1",
              content: "FAME pharmaceuticals"
          },
          {
              type: "Public2",
              content: "ရွှေပြည်နန်းသနပ်ခါး"
          }
      ]
  },
];

export default quizQuestions;
